
<template>

  <v-container
  >
  <div style="    text-align: center;margin-bottom: 5%">
    <img
            :src="appLogo"
            style="width: 16%;"
            class="img-responsive center mb-3"

    />
  </div>

    <v-layout wrap>
      <v-flex
              md12
              xs12
              lg3
      >
        </v-flex>
      <v-flex
              md12
              xs12
              lg6
      >
        <v-form
                align="center"
                v-model="valid" class="mb-4" @keyup.native.enter="valid && submit($event)">
          <v-flex col-md-5>
            <v-text-field

                    label="E-mail ID"
                    v-model="email"
                    :rules="emailRules"
                    required
            ></v-text-field>
            <v-text-field
                    label="Password"
                    v-model="password"
                    type="password"
                    :rules="passwordRules"
                    required
            ></v-text-field>
                  <my-captcha :callSuccess="captchaOk" color="black" mode="math" resolve="text" ref="captcha"></my-captcha>

            <v-checkbox
                    color="primary"
                    label="Remember me"
                    v-model="checkbox"
            ></v-checkbox>

            <router-link to="/session/forget-password">Forget Password?</router-link>
          </v-flex>

          <v-flex>
            <v-btn @click="submit" :disabled="!(email && password && isCaptchaValid)"  color="primary">Login Now</v-btn>
            <!-- <v-btn large @click="onCreateAccount" block color="warning">{{$t('message.createAccount')}}</v-btn> -->
          </v-flex>
          <!-- <p>{{$t('message.bySigningUpYouAgreeTo')}} {{brand}}</p> -->
          <!-- <router-link to="">{{$t('message.termsOfService')}}</router-link> -->
        </v-form>
      </v-flex>
    </v-layout>

  </v-container>
</template>




<script>

  import AppConfig from "../constants/AppConfig";
  import api from '../api';
  import { login } from '../api/routes';
  import router from 'vue-router'
  import myCaptcha from 'vue-captcha'

  // import AuthService from "../../auth/AuthService";

  // const auth = new AuthService();
  // const { login, logout, authenticated, authNotifier } = auth;

  export default {
    data() {

      return {
        checkbox: false,
        btndis: true,
        valid: false,
        isCaptchaValid: false,
        appLogo: "/img/logo.png",
        email: "",
        emailRules: [
          v => !!v || "E-mail is required"
        ],
        password: "",
        passwordRules: [v => !!v || "Password is required"],
      };
    },
    mounted(){
      if (sessionStorage.getItem('AUTH_TOKEN') != null) {
        this.$router.push("/list");
      }
    },
    methods: {
    captchaOk () {
      this.isCaptchaValid = true;
      console.log('captcha ok.!')
    },
    captchaBtn () {
     this.btndis = false
    },
    clicked () {
      alert('button active.!')
    },
      submit() {
        const user = {
          email: this.email,
          password: this.password
        };
        login(user)
                .then(response => {
                  response =response.data;
                  sessionStorage.setItem('AUTH_TOKEN', response.token)
                  sessionStorage.setItem('USER', JSON.stringify(response))
                  sessionStorage.setItem('USER_NAME', response.name)
                  sessionStorage.setItem('USER_EMAIL', response.email)
                  sessionStorage.setItem('CURRENT_LANGUAGE', 1)
                  this.$router.push("/dashboard");
                })
                .catch(error => {
                  console.log(error)
                  this.$refs.captcha.text = ''
                  this.$refs.captcha.auth = false
                  this.$refs.captcha.picture()
                  this.$toasted.show('Credentials not Matched!')
                });
      },

    },
    components: {
      'my-captcha': myCaptcha
    }
  };
</script>
<style  scoped>
  .center {
  margin: auto;


}
  .form {
    margin: 10px;
  }
  .row {
    margin: 10px;
  }
  .button {
    margin-top: 5px;
    background-color: #1D9D74;
    border: 1px solid transparent;
    border-radius: 3px;
    border-color: #dbdbdb;
    text-align: center;
    font-size: 1em;
    height: 2.25em;
    line-height: 1.5;
    color: white;
    cursor: pointer;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
  }
  .button[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }  
</style>
